import { forkJoin } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { TemplateModel } from 'projects/core/src/lib/models/template.model';
import { PartnerModel } from 'projects/core/src/lib/models/partner.model';
import { BaseDetail } from 'projects/admin/src/app/classes/base-detail';
import { TranslocoService } from '@ngneat/transloco';
import { DetailModes } from 'projects/admin/src/app/shared/constants';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { LanguageModel } from 'projects/core/src/lib/models/language.model';

@Component({
  selector: 'app-template-detail',
  templateUrl: './template-detail.component.html',
  styleUrls: ['./template-detail.component.scss']
})
export class TemplateDetailComponent extends BaseDetail implements OnInit {

  public template: TemplateModel = null;
  public partners: Array<PartnerModel> = [];
  public languages: Array<LanguageModel> = [];
  public backRoute = ['/templates'];

  protected identifier = 'template';

  constructor(
    protected router: Router,
    protected ui: UiService,
    protected helper: HelperService,
    protected transloco: TranslocoService,
    private api: ApiService,
    private route: ActivatedRoute,
  ) {
    super(ui, router, helper, transloco);
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params.id === 'new') {
        this.setInitialized(DetailModes.new);
      } else if (params.id) {
        this.setLoading();
        forkJoin([
          this.api.getModel('templates', params.id),
          this.api.getModels('partners'),
          this.api.getModels('languages'),
        ]).subscribe({
          next: (result: any) => {
            this.template = new TemplateModel().deserialize(result[0].data);
            this.tabIndex = parseInt(localStorage.getItem(this.identifier + '-tab'), 10);
            this.partners = (result[1]?.data?.length > 0) ? result[1].data.map((partner: any) => new PartnerModel().deserialize(partner)) : [];
            this.languages = (result[2]?.data?.length > 0) ? result[2].data.map((language: any) => new LanguageModel().deserialize(language)) : [];
            this.setInitialized(DetailModes.edit);
          },
          error: (error: any) => {
            this.setFailed(error);
          }
        });
      } else {
        this.onClose();
      }
    });
  }

}
